import { render } from "./PackageRegionItem.vue?vue&type=template&id=7cba9620&scoped=true"
import script from "./PackageRegionItem.vue?vue&type=script&lang=js"
export * from "./PackageRegionItem.vue?vue&type=script&lang=js"

import "./PackageRegionItem.vue?vue&type=style&index=0&id=7cba9620&scoped=true&lang=scss"

import exportComponent from "C:\\Bohdan\\telesim_test\\telesim-admin-panel\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cba9620"]])

export default __exports__